import { Box, Typography } from "@mui/material";
import { TransactionPaymentOptions } from "Components/Transactions/TransactionPaymentOptions";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.LicensePayment;

type Props = {
  transactionPublicID: string;
};

export const LicensePayment = ({ transactionPublicID }: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" flexDirection="column" gap={5}>
      <Typography align="left">{t(RESOURCES.PendingActivationInfo)}</Typography>
      <TransactionPaymentOptions
        transactionPublicID={transactionPublicID}
        isDirectPaymentHidden
      />
    </Box>
  );
};
